import { render } from "./Header.vue?vue&type=template&id=25b80918&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=25b80918&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b80918"]])

export default __exports__